/**
 * @flow
 * @relayHash 11f7059d908c8c2be23e4aaf55fd399d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ScheduleContainer_node$ref = any;
export type CreateUserEventSegmentInput = {
  clientMutationId?: ?string,
  user_event_id: string,
  title: string,
  start_at?: ?any,
  end_at?: ?any,
  time_zone?: ?string,
  location?: ?string,
  room?: ?string,
  line1?: ?string,
  line2?: ?string,
  city?: ?string,
  province?: ?string,
  postal_code?: ?string,
  country?: ?string,
  notes?: ?string,
};
export type ScheduleComponent_createUserEventSegmentMutationVariables = {|
  input: CreateUserEventSegmentInput
|};
export type ScheduleComponent_createUserEventSegmentMutationResponse = {|
  +createUserEventSegment: ?{|
    +user_event: ?{|
      +start_at: ?any,
      +end_at: ?any,
      +time_zone: ?string,
      +$fragmentRefs: ScheduleContainer_node$ref,
    |}
  |}
|};
export type ScheduleComponent_createUserEventSegmentMutation = {|
  variables: ScheduleComponent_createUserEventSegmentMutationVariables,
  response: ScheduleComponent_createUserEventSegmentMutationResponse,
|};
*/


/*
mutation ScheduleComponent_createUserEventSegmentMutation(
  $input: CreateUserEventSegmentInput!
) {
  createUserEventSegment(input: $input) {
    user_event {
      start_at
      end_at
      time_zone
      ...ScheduleContainer_node
      id
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUserEventSegmentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateUserEventSegmentInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "time_zone",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ScheduleComponent_createUserEventSegmentMutation",
  "id": null,
  "text": "mutation ScheduleComponent_createUserEventSegmentMutation(\n  $input: CreateUserEventSegmentInput!\n) {\n  createUserEventSegment(input: $input) {\n    user_event {\n      start_at\n      end_at\n      time_zone\n      ...ScheduleContainer_node\n      id\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ScheduleComponent_createUserEventSegmentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateUserEventSegmentPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "FragmentSpread",
                "name": "ScheduleContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ScheduleComponent_createUserEventSegmentMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createUserEventSegment",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateUserEventSegmentPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event_segments",
                "storageKey": "user_event_segments(first:99999)",
                "args": v6,
                "concreteType": "UserEventSegmentConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegmentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserEventSegment",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line1",
                            "args": null,
                            "storageKey": null
                          },
                          v5,
                          v2,
                          v3,
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "all_day",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "location",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line2",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "city",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "province",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postal_code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "room",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "notes",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "user_event_segments",
                "args": v6,
                "handle": "connection",
                "key": "ScheduleContainer_user_event_segments",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c069f1a97fe9f64586b141a5fb7189b6';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/ScheduleComponent_createUserEventSegmentMutation.graphql.js